import Vue from 'vue'

import '../styles/quasar.scss'
import lang from 'quasar/lang/ru.js'
import { Quasar, Notify, QBanner, QCard, QCheckbox, QIcon, Dialog, ClosePopup, Loading } from 'quasar'

import iconSet from 'quasar/icon-set/mdi-v6.js'
import '@quasar/extras/mdi-v6/mdi-v6.css'

Notify.setDefaults({
  actions: [{ icon: 'mdi-close', color: 'white' }]
})

Vue.use(Quasar, {
  config: {},
  components: { QBanner, QCard, QCheckbox, QIcon /* not needed if importStrategy is not 'manual' */ },
  directives: { ClosePopup },
  plugins: { Notify, Dialog, Loading },
  lang: lang,
  iconSet: iconSet
})
